import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=161833e2&"
import script from "./AppIndex.vue?vue&type=script&lang=js&"
export * from "./AppIndex.vue?vue&type=script&lang=js&"
import style0 from "./AppIndex.vue?vue&type=style&index=0&id=161833e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports